// extracted by mini-css-extract-plugin
export default {"main":"Promotion_main__IWtJy","top-banner-image":"Promotion_top-banner-image__lU2Ys"};